export default {
    getPhotos: (state) => (filter) => {
        if (filter === 'all' || filter === undefined) {
            return state.photos
        } else {
            return state.photos.filter(photo => photo.type === filter)
        }
    },

    getPhoto: (state) => (photoId) => {
        return state.photos.find(photo => photo.id === photoId)
    }
}